"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[255],{

/***/ 76021:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  O: () => (/* binding */ useSubscriptionCoupon)
});

// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
;// CONCATENATED MODULE: ./src/modules/subscription/coupon/graph/subscriptionCoupon.graphql.ts
const SubscriptionCouponDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "SubscriptionCoupon"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "CouponFilterInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "subscription"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "coupon"
                                                            },
                                                            "arguments": [
                                                                {
                                                                    "kind": "Argument",
                                                                    "name": {
                                                                        "kind": "Name",
                                                                        "value": "input"
                                                                    },
                                                                    "value": {
                                                                        "kind": "Variable",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "input"
                                                                        }
                                                                    }
                                                                }
                                                            ],
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "code"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "freeProduct"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "brandInfo"
                                                                                    },
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "name"
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "name"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "image"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "rebrandImage"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "typeGroup"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "unit"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "volume"
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
SubscriptionCouponDocument["definitions"] = [
    ...new Set(SubscriptionCouponDocument.definitions)
];
/* harmony default export */ const subscriptionCoupon_graphql = (SubscriptionCouponDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/coupon/index.ts


const useSubscriptionCoupon = (input)=>{
    var _data_currentUser_data_subscription, _data_currentUser_data, _data_currentUser;
    const { data, isFetching } = (0,useQuery/* default */.Z)(subscriptionCoupon_graphql, {
        variables: {
            input
        }
    });
    return {
        subscriptionCoupon: data === null || data === void 0 ? void 0 : (_data_currentUser = data.currentUser) === null || _data_currentUser === void 0 ? void 0 : (_data_currentUser_data = _data_currentUser.data) === null || _data_currentUser_data === void 0 ? void 0 : (_data_currentUser_data_subscription = _data_currentUser_data.subscription) === null || _data_currentUser_data_subscription === void 0 ? void 0 : _data_currentUser_data_subscription.coupon,
        isFetching
    };
};


/***/ }),

/***/ 37643:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ drift_getFullDriftProductName)
});

;// CONCATENATED MODULE: ./src/modules/subscription/drift/messages.ts
/* harmony default export */ const messages = ({
    defaultName: {
        en: "Wood Car Freshener"
    },
    defaultScent: {
        en: "Scent of the Month"
    },
    name: {
        en: "{name} in {variety}"
    },
    nameWithClip: {
        en: "{name} in {variety} with {clip}"
    }
});

;// CONCATENATED MODULE: ./src/modules/subscription/drift/getFullDriftProductName.ts

const getFullDriftProductName = (param)=>{
    let { productName, varietyName, driftDescription, formatMessage } = param;
    if (!varietyName) {
        return productName;
    }
    // TODO: Find a way to do this in a more flexible and fail-safe way? — added on 17–08–2023 by algeas
    const [productNameFromDesc, clipNameFromDesc] = (driftDescription === null || driftDescription === void 0 ? void 0 : driftDescription.split(" with ")) || [];
    return formatMessage({
        ...clipNameFromDesc ? messages.nameWithClip : messages.name,
        values: {
            clip: clipNameFromDesc,
            name: productNameFromDesc || productName || formatMessage(messages.defaultName),
            variety: varietyName || formatMessage(messages.defaultScent)
        }
    });
};
/* harmony default export */ const drift_getFullDriftProductName = (getFullDriftProductName);


/***/ }),

/***/ 74447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D: () => (/* binding */ usePlanPricesList),
  h: () => (/* binding */ usePrices)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(23450);
// EXTERNAL MODULE: ./src/helpers/getters/getPlanDifferencePercent.ts
var getPlanDifferencePercent = __webpack_require__(32834);
// EXTERNAL MODULE: ./src/modules/user/shipping/useCountryList.ts + 1 modules
var useCountryList = __webpack_require__(99084);
;// CONCATENATED MODULE: ./src/modules/subscription/prices/graph/plans.graphql.ts
const PlansDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Plans"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "PlansInquiryInput"
                            }
                        }
                    }
                },
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "gender"
                        }
                    },
                    "type": {
                        "kind": "NamedType",
                        "name": {
                            "kind": "Name",
                            "value": "UserGender"
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "plansInquiry"
                                                },
                                                "arguments": [
                                                    {
                                                        "kind": "Argument",
                                                        "name": {
                                                            "kind": "Name",
                                                            "value": "input"
                                                        },
                                                        "value": {
                                                            "kind": "Variable",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "input"
                                                            }
                                                        }
                                                    }
                                                ],
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "FragmentSpread",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "SubscriptionPlan"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "discount"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "defaultDiscountPrice"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "defaultDiscountText"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "defaultCoupon"
                                                                        },
                                                                        "selectionSet": {
                                                                            "kind": "SelectionSet",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "id"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "code"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "discountAmount"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "discountPercentage"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "extraShippingPrice"
                                                                                    }
                                                                                },
                                                                                {
                                                                                    "kind": "Field",
                                                                                    "name": {
                                                                                        "kind": "Name",
                                                                                        "value": "freeProduct"
                                                                                    },
                                                                                    "arguments": [
                                                                                        {
                                                                                            "kind": "Argument",
                                                                                            "name": {
                                                                                                "kind": "Name",
                                                                                                "value": "gender"
                                                                                            },
                                                                                            "value": {
                                                                                                "kind": "Variable",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "gender"
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    ],
                                                                                    "selectionSet": {
                                                                                        "kind": "SelectionSet",
                                                                                        "selections": [
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "id"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "name"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "brandInfo"
                                                                                                },
                                                                                                "selectionSet": {
                                                                                                    "kind": "SelectionSet",
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "kind": "Field",
                                                                                                            "name": {
                                                                                                                "kind": "Name",
                                                                                                                "value": "name"
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "typeGroup"
                                                                                                }
                                                                                            },
                                                                                            {
                                                                                                "kind": "Field",
                                                                                                "name": {
                                                                                                    "kind": "Name",
                                                                                                    "value": "rebrandImage"
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "SubscriptionPlan"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "SubscriptionPlan"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "name"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productCount"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productPrice"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productsPerPeriod"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "save"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "shippingPeriod"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "billingPeriod"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "category"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "description"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "definition"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "discount"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "defaultDiscountPrice"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "defaultDiscountText"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
PlansDocument["definitions"] = [
    ...new Set(PlansDocument.definitions)
];
/* harmony default export */ const plans_graphql = (PlansDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/prices/index.ts






const usePlanPricesList = function() {
    let { skip, ssr, couponCode, gender = "FEMALE", country, ...input } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { data: plansData, isFetching: isFetchingPlan, error } = (0,useQuery/* default */.Z)(plans_graphql, {
        variables: {
            gender,
            input: {
                billingPeriod: 1,
                shippingPeriod: 1,
                productsPerPeriod: 1,
                couponCode: couponCode || "",
                ...input
            }
        },
        skip,
        ssr,
        context: {
            ssrCache: true
        }
    });
    const finalCountry = country || "US";
    const { countryList, isFetching: isFetchingCountry } = (0,useCountryList/* default */.Z)({
        withRegions: false,
        skip: finalCountry === "US"
    });
    const isFetching = isFetchingPlan || isFetchingCountry;
    const data = (0,react.useMemo)(()=>{
        var _plansData_currentUser_data, _plansData_currentUser;
        const plans = plansData === null || plansData === void 0 ? void 0 : (_plansData_currentUser = plansData.currentUser) === null || _plansData_currentUser === void 0 ? void 0 : (_plansData_currentUser_data = _plansData_currentUser.data) === null || _plansData_currentUser_data === void 0 ? void 0 : _plansData_currentUser_data.plansInquiry;
        if (!plans) {
            return null;
        }
        const countryInfo = countryList ? countryList.find((param)=>{
            let { alpha2 } = param;
            return alpha2 === finalCountry;
        }) : null;
        const { shippingPrice = 0 } = countryInfo || {};
        return plans.map((plan)=>{
            var _plan_discount, _plan_discount1;
            const price = plan.price;
            const priceWithDiscount = (_plan_discount = plan.discount) === null || _plan_discount === void 0 ? void 0 : _plan_discount.defaultDiscountPrice;
            const formattedPrice = price ? (0,formatPrice/* default */.Z)(price) : null;
            const formattedPriceWithDiscount = priceWithDiscount !== undefined ? (0,formatPrice/* default */.Z)(priceWithDiscount) : null;
            let { code, extraShippingPrice = 0, discountAmount, discountPercentage, freeProduct } = ((_plan_discount1 = plan.discount) === null || _plan_discount1 === void 0 ? void 0 : _plan_discount1.defaultCoupon) || {};
            extraShippingPrice = extraShippingPrice + shippingPrice;
            const isFreeTrial = priceWithDiscount === 0 && extraShippingPrice > 0;
            // TODO detect "2nd month offer" on backend in API - added on 12.04.2022 by sonatskiy
            const isSecondMothFreeOffer = code === "2ND_MTH_FREE_8FE998";
            const isFreeProductOffer = Boolean(freeProduct === null || freeProduct === void 0 ? void 0 : freeProduct.id);
            const isFreeCaseOffer = (freeProduct === null || freeProduct === void 0 ? void 0 : freeProduct.typeGroup) === "PerfumeCase";
            const formattedExtraShippingPrice = extraShippingPrice ? (0,formatPrice/* default */.Z)(extraShippingPrice) : null;
            const formattedDiscountAmount = discountAmount ? (0,formatPrice/* default */.Z)(discountAmount) : null;
            const discountPercent = discountPercentage ? `${discountPercentage}%` : null;
            let eventDiscountText;
            let offerType;
            if (isFreeTrial) {
                eventDiscountText = finalCountry !== "US" ? `${formattedExtraShippingPrice} delivery discount` : "Free trial";
                offerType = "freeTrial";
            } else if (isSecondMothFreeOffer) {
                eventDiscountText = "Free 2nd month product";
                offerType = "free2ndMonth";
            } else if (isFreeProductOffer) {
                eventDiscountText = isFreeCaseOffer ? "Free case" : "Free product";
                offerType = "freeProduct";
            } else {
                eventDiscountText = discountPercent || formattedDiscountAmount || "No offer";
                offerType = discountAmount || discountPercent ? "discount" : null;
            }
            // TODO refactor it to something more pretty :) - added on 12.04.2022 by sonatskiy
            return {
                plan: {
                    ...plan,
                    percentageDiscount: (0,getPlanDifferencePercent/* default */.Z)(plans[0].productPrice, plan.productPrice)
                },
                price,
                priceWithDiscount,
                extraShippingPrice,
                formattedPrice,
                formattedPriceWithDiscount,
                formattedExtraShippingPrice,
                eventDiscountText,
                discountAmount: formattedDiscountAmount,
                discountPercent,
                freeProduct,
                offerType,
                isFreeTrial,
                isSecondMothFreeOffer,
                isFreeProductOffer,
                isFreeCaseOffer
            };
        });
    }, [
        plansData,
        countryList,
        finalCountry
    ]);
    return {
        data,
        isFetching,
        error
    };
};
const usePrices = (props)=>{
    const { data, isFetching, error } = usePlanPricesList(props);
    return {
        ...data === null || data === void 0 ? void 0 : data[0],
        isFetching,
        error
    };
};


/***/ }),

/***/ 70104:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Hu: () => (/* binding */ useSubscribeOffer),
/* harmony export */   ds: () => (/* binding */ SubscribeOfferProvider)
/* harmony export */ });
/* unused harmony export useSubscribeOfferProvider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9424);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63687);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13284);
/* harmony import */ var modules_coupon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62328);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74447);







const SubscribeOfferContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)(null);
const useSubscribeOffer = ()=>(0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(SubscribeOfferContext);
const useSubscribeOfferProvider = (defaultCouponCode)=>{
    const [, forceUpdate] = (0,hooks__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const { couponCode, cookieCouponCode, setCookieCoupon } = (0,modules_coupon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(defaultCouponCode);
    const country = cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.cookieNames.country);
    const { formattedPrice, formattedPriceWithDiscount, formattedExtraShippingPrice, eventDiscountText, discountPercent, discountAmount, isFetching, offerType } = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_6__/* .usePrices */ .h)({
        couponCode,
        country
    });
    const discountText = discountPercent || discountAmount;
    const handleSubscribeClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setCookieCoupon(couponCode);
    }, [
        setCookieCoupon,
        couponCode
    ]);
    // use if you want to replace coupon globally
    const replaceCoupon = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((code)=>{
        setCookieCoupon(code);
        forceUpdate();
    }, [
        setCookieCoupon,
        forceUpdate
    ]);
    return {
        couponCode,
        cookieCouponCode,
        formattedPrice,
        formattedPriceWithDiscount,
        formattedExtraShippingPrice,
        offerType,
        discountText,
        discountAmount,
        discountPercent,
        eventDiscountText,
        isFetching,
        handleSubscribeClick,
        replaceCoupon,
        forceUpdate
    };
};
const SubscribeOfferProvider = (param)=>{
    let { children, defaultCouponCode } = param;
    const value = useSubscribeOfferProvider(defaultCouponCode);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SubscribeOfferContext.Provider, {
        value: value,
        children: children
    });
};


/***/ }),

/***/ 36888:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  qR: () => (/* binding */ SubscriptionProvider),
  FX: () => (/* binding */ useIsSubscriptionUpdating),
  mU: () => (/* binding */ useSubscription)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useQuery.ts
var useQuery = __webpack_require__(11396);
;// CONCATENATED MODULE: ./src/modules/subscription/subscription/graph/subscription.graphql.ts
const SubscriptionDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "query",
            "name": {
                "kind": "Name",
                "value": "Subscription"
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "currentUser"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "personalInfo"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "id"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "analyticsMetadata"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "FragmentSpread",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "AnalyticsMetadata"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "addressInfo"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "status"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "FragmentSpread",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "Subscriptions"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Subscription"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "ScentbirdSubscription"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "id"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "status"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "value"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "statusText"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "subscribed"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "plan"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "name"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "billingPeriod"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "shippingPeriod"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "productCount"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "productsPerPeriod"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "description"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "price"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "productPrice"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "credits"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "total"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "paid"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "free"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "freeForReferral"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "freeForReferee"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "customerSupport"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "gift"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "nextShippingDate"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "from"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "to"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "nextBillingDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "nextBillingPrice"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "activeHold"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "monthsDuration"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "range"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "from"
                                                }
                                            },
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "to"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "coupon"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "id"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "code"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "stateOptions"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canBuyQueue"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canCancel"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canChangeFrequency"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canDowngrade"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canResubscribe"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canSkip"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "canUpgrade"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "isResubscribed"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "remainingShipments"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AddonSubscription"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "CaseSubscription"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "kind"
                        }
                    },
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "isEnabled"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "enabled"
                        }
                    },
                    {
                        "kind": "Field",
                        "alias": {
                            "kind": "Name",
                            "value": "isSelected"
                        },
                        "name": {
                            "kind": "Name",
                            "value": "selected"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "price"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "priceDetails"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "amountCents"
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "currencyCode"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "state"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "upcharge"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "status"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "AnalyticsMetadata"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "AnalyticsMetadata"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "mixpanelClientId"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "daysFromFirstSubscription"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "firstSubscriptionDate"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lifetimeStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "lifeTimeRevenue"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "hasScentProfile"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "productsInQueueQty"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionStatus"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionPlan"
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "isGiftSubscription"
                        }
                    }
                ]
            }
        },
        {
            "kind": "FragmentDefinition",
            "name": {
                "kind": "Name",
                "value": "Subscriptions"
            },
            "typeCondition": {
                "kind": "NamedType",
                "name": {
                    "kind": "Name",
                    "value": "UserData"
                }
            },
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscription"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "Subscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "caseSubscription"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "candleSubscription"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "driftSubscription"
                        },
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "FragmentSpread",
                                    "name": {
                                        "kind": "Name",
                                        "value": "AddonSubscription"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "canApplyTossInOffer"
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
SubscriptionDocument["definitions"] = [
    ...new Set(SubscriptionDocument.definitions)
];
/* harmony default export */ const subscription_graphql = (SubscriptionDocument);

;// CONCATENATED MODULE: ./src/modules/subscription/subscription/index.tsx




const modifySubscription = (data)=>{
    var _personalInfo_addressInfo, _subscription_plan, _subscription_stateOptions;
    const { personalInfo, subscription, canApplyTossInOffer, caseSubscription, candleSubscription, driftSubscription } = data;
    const { name: statusName, subscribed = false } = (subscription === null || subscription === void 0 ? void 0 : subscription.status) || {};
    const addressStatus = personalInfo === null || personalInfo === void 0 ? void 0 : (_personalInfo_addressInfo = personalInfo.addressInfo) === null || _personalInfo_addressInfo === void 0 ? void 0 : _personalInfo_addressInfo.status;
    const isMonthlyPlan = (subscription === null || subscription === void 0 ? void 0 : (_subscription_plan = subscription.plan) === null || _subscription_plan === void 0 ? void 0 : _subscription_plan.name) === "MONTHLY";
    const isUpgradableFromMonthlyPlan = isMonthlyPlan && (subscription === null || subscription === void 0 ? void 0 : (_subscription_stateOptions = subscription.stateOptions) === null || _subscription_stateOptions === void 0 ? void 0 : _subscription_stateOptions.canUpgrade);
    const isShippingAddressInvalid = addressStatus === "UNDELIVERABLE" || addressStatus === "UNABLE_MANUALLY_VALIDATE";
    const isShippingAddressUndeliverable = addressStatus === "UNDELIVERABLE" || statusName === "Undeliverable";
    return {
        ...subscription,
        isMonthlyPlan,
        isUpgradableFromMonthlyPlan,
        hasNeverSubscribed: !statusName || statusName === "NotSubscribed",
        isSubscribed: subscribed,
        isActive: statusName === "Active",
        isCancelled: statusName === "Cancelled",
        isOnHold: statusName === "OnHold",
        isOnTechnicalHold: statusName === "OnTechnicalHold",
        isPaymentInProgress: statusName === "PaymentInProgress",
        isPending: statusName === "Pending",
        isPendingChangePlan: statusName === "PendingChangePlan",
        isPendingUpgrade: statusName === "PendingUpgrade",
        isUndeliverable: statusName === "Undeliverable",
        isUnpaid: statusName === "Unpaid",
        isShippingAddressInvalid,
        isShippingAddressUndeliverable,
        canApplyTossInOffer,
        hasCaseSubscription: (caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected) || false,
        hasCandleSubscription: (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected) || false,
        hasDriftSubscription: (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected) || false,
        isCaseSubscriptionAvailable: (caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled) && !(caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected),
        isCandleSubscriptionAvailable: (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected)
    };
};
const SubscriptionContext = /*#__PURE__*/ (0,react.createContext)(null);
const SubscriptionProvider = (param)=>{
    let { children } = param;
    const { data: subscriptionData, isFetching, error, client } = (0,useQuery/* default */.Z)(subscription_graphql, {
        fetchPolicy: "cache-first"
    });
    // ATTN to get updated data, you should add refetchQueries and awaitRefetchQueries to your mutation
    const getSubscriptionFromCache = (0,react.useCallback)(()=>{
        const data = client.cache.readQuery({
            query: subscription_graphql
        });
        if (!data) {
            return null;
        }
        return modifySubscription(data.currentUser.data);
    }, [
        client
    ]);
    // ATTN the data is null, when data is loading, but it is defined when user doesn't have subscription
    const subscription = (0,react.useMemo)(()=>{
        var _subscriptionData_currentUser;
        if (!(subscriptionData === null || subscriptionData === void 0 ? void 0 : (_subscriptionData_currentUser = subscriptionData.currentUser) === null || _subscriptionData_currentUser === void 0 ? void 0 : _subscriptionData_currentUser.data)) {
            return null;
        }
        return modifySubscription(subscriptionData.currentUser.data);
    }, [
        subscriptionData
    ]);
    const value = {
        subscription,
        isFetching,
        error,
        getSubscriptionFromCache
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionContext.Provider, {
        value: value,
        children: children
    });
};
const useSubscription = ()=>(0,react.useContext)(SubscriptionContext);
// returns true when subscription query is in progress, updating info
const useIsSubscriptionUpdating = ()=>{
    const { isFetching } = (0,useQuery/* default */.Z)(subscription_graphql, {
        fetchPolicy: "cache-only",
        notifyOnNetworkStatusChange: true
    });
    return isFetching;
};


/***/ })

}]);